$(function(){
//init
$("#ssw-fave-list-widget").hide();
$("#ssw-widget-review-bar").hide();
$("#chatra").hide();
$("#ssw-fave-side-button-wrapper").hide();
});

function hideScroller() {
//correction code for cart page
var atcexists = $('.product-form__submit.button').length > 0;
  
//wishlist
wishlist = $("#ssw-fave-list-widget");
  
//wishlist, tier 2 (if first doesnt hide)
wishlistt2 = $("#ssw-fave-side-button-wrapper");

//store reviews 
storerevs = $("#ssw-widget-review-bar");

// chat
chat = $("#chatra");
  
wishlist.hide();
wishlistt2.hide();
storerevs.hide();
chat.hide();

  //correction code in case of cart page.
  if (atcexists == true){
    actionbtn = $('.product-form__submit.button');  
    actionfromtop = actionbtn.offset().top + 1300; 
  }
        
  else { 
    actionbtn = $('button#checkout'); 
    actionfromtop = actionbtn.offset().top + 1700; 
  }

  subfromtop = $(window).scrollTop()+$(window).height();

        if (actionfromtop > subfromtop) { 
      wishlist.hide();
      wishlistt2.hide();
      storerevs.hide();
      chat.hide(); 
        }
        else {
        wishlist.show();
        wishlistt2.show();
        storerevs.show();
        chat.show();
        
        }
      }

//triggers
$(document).ready(function () {
    hideScroller();
    });

$(window).scroll(function () {
    hideScroller();
});

//upon ATC or header click (backup function)

$(".add-to-cart").click(function(){
  $("#ssw-fave-list-widget").hide();
    $("#ssw-fave-side-button-wrapper").hide();
  $("#ssw-widget-review-bar").hide();
  $("#chatra").hide();

  });

$(".header__icon--cart").click(function(){
  $("#ssw-fave-list-widget").hide();
    $("#ssw-fave-side-button-wrapper").hide();
  $("#ssw-widget-review-bar").hide();
  $("#chatra").hide();
                                     
});





